import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './assets/styles/app.scss'
import store from './store'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <Provider store={store}>
    <BrowserRouter basename="/vong-xoay-quyen-nang/">
      {/* <BrowserRouter> */}
      <App />
    </BrowserRouter>
  </Provider>
)
